import { LicenseData } from "../types/LicenseData";
import { ExpiryData } from "../types/LicenseData";

let initialState: ExpiryData = {
    endDate: '',
    postExpiryAccessibilityDays: 7,
    showDialog: false
}

const postLicenseExpiryReducer = (state:ExpiryData = initialState, action: LicenseData)  => {
    switch(action.type){
        case 'SHOW_LICENSE_EXPIRY_DIALOG':
            
            let showLicenseExpiryDialog:boolean = false;

            // Current Date <= (expirydate + pEADs) -> showDialog: true
            
            return {
                ...state,
                endDate: action.data.endDate,
                postExpiryAccessibilityDays: action.data.postExpiryAccessibilityDays,
                showDialog: showLicenseExpiryDialog
            }
        default:
            return state;
    }
}

export default postLicenseExpiryReducer;